import React from "react";
import Section from "../../Blog/BlogModern/Section";
import BlogModernContent from "../../Blog/BlogModern/BlogModernContent";

const BlogModern = () => {
  document.title = "Blog Modern - Matrix Executive Search Group";
  return (
    <React.Fragment>
      <Section />
      <BlogModernContent />
    </React.Fragment>
  );
};

export default BlogModern;
